import script from "./ReviewAppsFormInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewAppsFormInput.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewAppsFormInput.vue?vue&type=style&index=0&id=6e44e8ac&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e44e8ac"]])

export default __exports__